import { RestServiceConnection } from "../RestServiceConnection";


export class LabelService extends RestServiceConnection {
    
    search = async (filter: any) => {
        this.response = await this.makeRequest({
            method: "post",
            url: '/label/search',
            data: filter
        }, true);
        return this;
    }

}